import React, { useState, useEffect, Fragment } from "react";
import { SlDrawer, SlButton, SlProgressBar } from "@shoelace-style/shoelace/dist/react";
import { useForm, Controller } from "react-hook-form";
import API from "../../services/api";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { brandLabels, BrandsTypes, langoptions, roles } from "../../utils/constants";
import Select from "react-select";
function AddBrand(props) {
  const [progress, setProgress] = useState(0);
  const [imgUrl, setImgUrl] = useState("");
  const [uploadImage, setUploadImage] = useState(null)
  const [locations,setlocations] = useState([]);
  const [showCustomLocation, setShowCustomLocation] = useState(false);
  const adTypeOptions = [
    { label: "Finite", value: "Finite" },
    { label: "Infinite", value: "Infinite" },
    // { label: "Local", value: "Local" },
    // { label: "Others", value: "Others" }
  ]
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  const imageChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].type === "image/jpg" || e.target.files[0].type === "image/jpeg" || e.target.files[0].type === "image/webp" || e.target.files[0].type === "image/png") {
        setUploadImage(e.target.files[0]);
      } else {
        Toast("error", "Only jpg, jpeg, webp, png formats accepted")
        form1.setValue("brand_logo_url", null)
      }
    } else {
      if (props.flag === "edit") {
        setImgUrl(props.editData?.logo_url);
      } else {
        setProgress(0);
        setImgUrl("");
      }
    }
  };
  const formData = new FormData();
  formData.append("files", uploadImage);
  const imageUrl = async () => {
    try {
      let url = await API({
        url: `/upload/birdviewimage`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: data => {
          setProgress(Math.round((100 * data.loaded) / data.total))
        },
      });
      if (url.code === 200) {
        setImgUrl(url.data.data);
        setUploadImage()
      } else {
        setProgress(0);
        form1.setValue("brand_logo_url", null);
        if (props.flag === "edit") setUploadImage("");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };

  const form1 = useForm();

  const onSubmit = async (data) => {
    // console.log(data.brand_location)
    if (!data.brand_location || data.brand_location === '' || data.brand_location === null) {
      form1.setError('brand_location', {
        type: 'manual',
        message: 'Brand location is required!'
      });
      return;
    }
    if (props.flag === "add") {
      try {
        let res = await API({
          url: "/birdview/insertBrand",
          method: "POST",
          responseType: "json",
          data: {
            brand_name: data.brand_name,
            brand_location: data.brand_location,
            brand_category: data.brand_category.value,
            // lang_id: data.lang_id.value,
            status: data.status,
            ad_type: data.ad_type.value,
            brand_logo_url: imgUrl,
            alias_names: data.alias_names.split(',').map(item => {if(item) return item.trim().toLowerCase()}).filter(item => item),
            brand_label: data.brand_label?.value || null,
            brand_type:data.brand_type
          },
        });
        if (res.code === 200) {
          Toast("success", "Brand added Successfully");
          props.loadData(0);
          props.setShow(false);
        } else {
          Toast("error", res?.message);
        }
      } catch (error) {
        console.error(error);
      }
    } else if (props.flag === "edit") {
      try {
        let res = await API({
          url: "/birdview/editBrand",
          method: "POST",
          responseType: "json",
          data: {
            brand_name: data.brand_name,
            brand_location: data.brand_location,
            brand_category: data.brand_category.value,
            // lang_id: data.lang_id.value,
            status: data.status,
            brand_id: props.actionId.id,
            ad_type: data.ad_type.value,
            brand_logo_url: imgUrl || props.editData?.logo_url,
            alias_names: data.alias_names.split(',').map(item => {if(item) return item.trim().toLowerCase()}).filter(item => item),
            brand_label: data.brand_label?.value || null,
            brand_type: data.brand_type
          },
        });
        if (res.code === 200) {
          Toast("success", "Brand udpated Successfully");
          if(props.flag === "edit") {
            props.loadData(props.currentPage);
          }
          else{
            props.setCurrentPage(0);
            props.loadData(0);
          }
          props.setShow(false);
          props.setEditData();
          props.setActionId()
        }
      } catch (error) {
        console.error(error);
      }
    }
  };
  const getbrandLocations = async()=>{
    try{
      const res = await api({ url: `/birdview/brandsLocations`, method: "POST", data: {}});
      if (res.code === 200){
        setlocations(res.data?.result);
      } 
    }catch(err){
      console.log(err);
    }
  }
  useEffect(()=>{
   getbrandLocations();
  },[])

  useEffect(() => {
    if (props.flag === "edit" && locations.length > 0 && props.editData?.brand_location) {
        const selectedLocation = locations.find(
            option => option.value === props.editData.brand_location
        );
        if (selectedLocation) {
            form1.setValue('brand_location', selectedLocation.value);
        }
    }
  }, [locations, props.flag, props.editData]);

  useEffect(() => {
    if (props.flag === "edit") {
      form1.setValue('brand_category', props.categories.find(option => option.value === props.editData.brand_category))
      form1.setValue('brand_label', brandLabels.find(option => option.value === props.editData.brand_label))
      // form1.setValue('lang_id', langoptions.find(option => option.value === props.editData.brand_language))
      form1.setValue('ad_type', adTypeOptions.find(option => option.value === props.editData.ad_type))

    }
  }, [])

  useEffect(() => {
    if (uploadImage) {
      imageUrl()
    }
  }, [uploadImage])
  return (
    <>
      <SlDrawer
        label="Add Brand"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => {
          props.setShow(false);
          props.setEditData();
        }}
      >
        <div>
          <form onSubmit={form1.handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label className="form-label">Brand Name</label>
              <input
                className="form-control"
                placeholder="Enter Brand Name"
                defaultValue={
                  props.flag === "edit" ? props.editData.brand_name : ""
                }
                {...form1.register("brand_name", { required: true })}
              ></input>
              {form1.formState.errors.brand_name && (
                <p className="text-red-600">Brand name is required!</p>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">Ad Type</label>
              <Controller
                name="ad_type" // Set the name to "ad_type"
                control={form1.control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="ad_type" // Ensure the name is consistent
                    placeholder="Select Ad Type"
                    options={adTypeOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                )}
              />
              {form1.formState.errors.ad_type && (
                <p className="text-red-600">Ad Type is Required!</p>
              )}
            </div>


            <div className="mb-3">
            <div className="flex items-center justify-between mb-2">
              <label className="form-label">Brand Location</label>
              <button
                type="button"
                className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700 transition-colors"
                onClick={() => {
                  setShowCustomLocation(!showCustomLocation);
                  form1.setValue('brand_location', null);
                }}
              >
                {showCustomLocation ? "← Select from list" : "+ Add Custom Location"}
              </button>
            </div>
            {!showCustomLocation ? (
              // Original Select Dropdown
              <Controller
                name="brand_location"
                control={form1.control}
                rules={{ 
                  required: "Brand location is required!",
                  validate: value => {
                    if (!value || value === '' || value === null) {
                      return "Brand location is required!";
                    }
                    return true;
                  }
                }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      name="brand_location"
                      placeholder="Select location"
                      options={locations}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      value={locations.find(opt => opt.value === field.value) || null}
                      onChange={opt => field.onChange(opt ? opt.value : "")}
                    />
                  );
                }}
              />
            ) : (
              <input
                className="form-control"
                placeholder="Enter custom location"
                {...form1.register("brand_location", { required: true })}
                onChange={(e)=>{
                  const loc = e.target.value || '';
                  const exist = locations.find(l => l?.label?.toLowerCase()===loc.toLowerCase());
                  if (exist) {
                    form1.setValue("brand_location", exist.value);
                    setShowCustomLocation(false);
                  }
                }}
              />
            )}
            {form1.formState.errors.brand_location && (
              <p className="text-red-600">Brand location is required!</p>
            )}
          </div>
            {/* <div className="mb-3">
              <label className="form-label">Brand Category</label>
              <input
                className="form-control"
                placeholder="Enter Brand Category"
                defaultValue={
                  props.flag === "edit" ? props.editData.brand_category : ""
                }
                {...form1.register("brand_category", { required: true })}
              ></input>
              {form1.formState.errors.brand_category && (
                <p className="text-red-600">Brand category is required!</p>
              )}
            </div> */}

            <div className="mb-3">
              <label className="form-label">Brand Category</label>
              <Controller
                name="brand_category"
                control={form1.control}
                rules={{ required: true }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      name="brand"
                      placeholder="Select Category"
                      options={props.categories}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  );
                }}
              />

              {
                form1.formState.errors.brand_category && <p className="text-red-600">Category is Required!</p>
              }
            </div>
            <div className="mb-3">
              <label className="form-label">Brand Label</label>
              <Controller
                name="brand_label"
                control={form1.control}
                rules={{ required: false }}
                render={({ field }) => {
                  return (
                    <Select
                      {...field}
                      name="brand_label"
                      placeholder="Select Label"
                      options={[{label: "Select", value: 0},...brandLabels]}
                      className="basic-multi-select"
                      classNamePrefix="select"
                    />
                  );
                }}
              />
            </div>

            {/* <div className="mb-3">
              <label className="form-label">Brand Language</label>
              <Controller
                name="lang_id" // Name of the form field
                control={form1.control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Select
                    {...field}
                    name="language"
                    placeholder={"Select Language"}
                    options={langoptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                )}
              />
              {
                form1.formState.errors.lang_id && <p className="text-red-600">Language is Required!</p>
              }
            </div> */}

            <div className="mb-3">
              <label className="form-label">Logo</label><br />
              <input
                className="form-control mb-2"
                type="file"
                id="formFile"
                name="files"
                {...form1.register("brand_logo_url", {
                  required: props.flag === "edit" ? false : true,
                  onChange: (e) => imageChange(e),
                })}
              />

              {form1.formState.errors.brand_logo_url && (
                <p className="text-red-600">Brand Logo is required!</p>
              )}
              {
                progress > 0 && progress < 100 ? <SlProgressBar value={progress}>{progress}%</SlProgressBar> : imgUrl !== "" ? (
                  <span>{`${imgUrl}`}</span>
                ) : (
                  props.flag === "edit" && <span>{`${props.editData?.logo_url}`}</span>
                )}
            </div>

            <div className="mb-3">
              <label className="form-label">Alias Brand Name</label>
              <input
                className="form-control"
                placeholder="Enter Alias Brand Name"
                defaultValue={
                  props.flag === "edit" ? props.editData.alias_names : ""
                }
                {...form1.register("alias_names", { required: false, pattern: {value : /^\s*([\w\s]+(\s*,\s*[\w\s]+)*)\s*$/, message: "Names should be in comma seperated"}})}
              ></input>
              {form1.formState.errors.alias_names && (
                <p className="text-red-600">{form1.formState.errors.alias_names.message}</p>
              )}
            </div>
            {props.flag === "edit" && (
              <div className="mb-3">
                <label className="form-label">Status</label>
                <br></br>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    defaultChecked={props?.editData?.status === 1}
                    {...form1.register("status")}
                    value="1"
                  />
                  <label class="form-check-label" for="inlineRadio1">
                    Active
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    defaultChecked={props?.editData?.status === 0}
                    {...form1.register("status")}
                    value="0"
                  />
                  <label class="form-check-label" for="inlineRadio2">
                    Inactive
                  </label>
                </div>
              </div>
            )}
            <div className="mb-3">
                <label className="form-label">National / Local</label>
                <br></br>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="None"
                    defaultChecked={props?.editData?.brand_type === 0}
                    {...form1.register("brand_type", {required: true})}
                    value="0"
                  />
                  <label class="form-check-label" for="None">
                    None
                  </label>
                </div>
                {BrandsTypes.map((brand)=> (
                 
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="National"
                    defaultChecked={props?.editData?.brand_type === brand.value}
                    {...form1.register("brand_type", {required: true})}
                    value={`${brand.value}`}
                  />
                  <label class="form-check-label" for="National">
                    {brand.label}
                  </label>
                </div>
               
                ))}
                {form1.formState.errors.brand_type && (
                <p className="text-red-600">{"Please select an option"}</p>
              )}
              </div>
            <div className="mb-3">
              <SlButton type="submit" variant="primary" size="small">
                Submit
              </SlButton>
            </div>
          </form>
        </div>
      </SlDrawer>
    </>
  );
}

export default AddBrand;
